module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-13.b25dd04f.svg";